import { useState } from "react";
import { ExternalLink, Page } from "../components/ui.jsx";
import { buildIndex } from "../lib/searchIndex.js";

export default function Search({ back, go, userRank }) {
  const [q, setQ] = useState("");
  const index = buildIndex(userRank);
  const needle = q.trim().toLowerCase();

  const results = needle
    ? index
        .filter(
          (r) =>
            !r.locked && (r.name + " " + (r.desc || "")).toLowerCase().includes(needle),
        )
        .slice(0, 20)
    : [];

  const body = (r, arrow) => (
    <>
      <div className="name">
        <span className="lead">
          <span>{r.icon}</span>
          <span>{r.name}</span>
        </span>
        <span className="arrow">{arrow}</span>
      </div>
      {r.desc && <div className="desc">{r.desc}</div>}
    </>
  );

  return (
    <Page
      back={back}
      eyebrow="Find It Fast"
      title="Search."
      intro="Pages, codes, classes, GroupMes, events, files — one box for the whole room."
    >
      <input
        className="finput"
        style={{ fontSize: 17 }}
        autoFocus
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Try “prayer night”, “code 5”, “rehearsal”…"
      />

      {needle === "" && (
        <div className="empty-note">Start typing — results appear as you go.</div>
      )}
      {needle !== "" && results.length === 0 && (
        <div className="empty-note">Nothing yet — try fewer words.</div>
      )}

      {results.map((r, i) =>
        r.p ? (
          <button key={i} className="card" onClick={() => go(r.p)}>
            {body(r, "→")}
          </button>
        ) : (
          <ExternalLink key={i} id={r.linkId}>
            {body(r, "↗")}
          </ExternalLink>
        ),
      )}
    </Page>
  );
}
